import Reveal from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Tell us where you want to go",
    desc: "We learn your business, audience, goals and content.",
  },
  {
    n: "02",
    title: "We build the machine",
    desc: "We source the right specialists and manage the entire production process.",
  },
  {
    n: "03",
    title: "You approve when needed",
    desc: "You stay involved where your input actually matters. We handle everything else.",
  },
];

export default function HowItWorks() {
  return (
    <section className="bg-white py-28 sm:py-40" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <span className="eyebrow text-[#86868b]">How it works</span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.06] text-[#1d1d1f]">
            Three steps. Then the machine runs.
          </h2>
        </Reveal>

        <div className="relative mt-16 sm:mt-20 grid md:grid-cols-3 gap-12 md:gap-10">
          <div className="hidden md:block absolute left-0 right-0 top-7 h-px bg-black/[0.08]" aria-hidden="true" />
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12} y={32}>
              <div className="group relative" data-testid={`how-step-${s.n}`}>
                <span className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full border border-black/10 bg-white font-display text-sm font-semibold text-[#86868b] shadow-[0_10px_26px_rgba(0,0,0,0.06)] transition-all duration-500 group-hover:bg-[#0a0a0a] group-hover:text-white group-hover:border-[#0a0a0a] group-hover:scale-110">
                  {s.n}
                </span>
                <h3 className="mt-8 font-display text-2xl font-semibold tracking-[-0.02em] text-[#1d1d1f]">
                  {s.title}
                </h3>
                <p className="mt-3 text-[15px] text-[#6e6e73] leading-relaxed max-w-xs">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
